import { Component, computed, input } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../../../environments/environment';
import { SentryFeedbackDirective } from '../../../monitoring/directives/sentry-feedback.directive';
import { TechnicalMonitoringEnabledDirective } from '../../../monitoring/directives/technical-monitoring-enabled.directive';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';

@Component({
  selector: 'app-parse-request-create-header',
  imports: [
    Button,
    NgIcon,
    RouterLink,
    TranslocoPipe,
    SentryFeedbackDirective,
    TechnicalMonitoringEnabledDirective,
    FeatureEnabledDirective,
  ],
  templateUrl: './parse-request-create-header.html',
})
export class ParseRequestCreateHeader {
  organizationId = input.required<string>();

  protected headerBarInfoButtonLink = computed(
    () => environment.articles.parseRequest.headerBarInfoButton,
  );
}
